import {
  apiProCheckUnlocked,
  apiTcmktCheckDeposit,
  apiTcmktCheckDepositHowToTrade,
  apiTcmktCheckTnc,
  apiTcmktTncAccept,
  apiDepositBlacklist,
} from '@/resource'
import { checkAgreedTNC } from '@/util/validation'
import { COUNTRY_MIN_LIMIT } from '@/constants/protraderTools'
export default {
  data() {
    return {
      needDeposit: false,
      needDepositHowToTrade: false,
      needAccept: false,
      form: {
        checked: false,
      },
      rule: {
        checked: [{ validator: checkAgreedTNC, trigger: 'change' }],
      },
      path: '',
    }
  },
  async mounted() {
    if (this.tradingToolUrl) {
      this.checkDeposits()
    }
  },
  methods: {
    async checkDeposits() {
      const unlocked = await apiProCheckUnlocked()
      const deposit = await apiTcmktCheckDeposit({
        ...(this.isAcuitySignalCentre && { pageType: 2 }),
      })
      const depositHowToTrade = await apiTcmktCheckDepositHowToTrade()
      const checkTnc = await apiTcmktCheckTnc()
      this.needUnlock = !unlocked.data.data.tcMktUnlocked
      this.needDeposit = !deposit.data.data
      this.needDepositHowToTrade = !depositHowToTrade.data.data
      this.needAccept = !checkTnc.data.data

      if ((!this.needDeposit && !this.needAccept) || !this.needUnlock) this.getUrl()
    },
    onSubmit() {
      this.$refs['tradingToolForm'].validate(valid => {
        if (valid)
          apiTcmktTncAccept().then(resp => {
            if (resp.data.data) {
              this.needAccept = false
              this.getUrl()
            }
          })
        else return false
      })
    },
    getUrl() {
      this.$store.dispatch('common/actionTradingToolUrl').then(resp => {
        if (resp) this.setPath()
      })
    },
    setPath() {
      this.path = this.tradingToolUrl[this.$route.name]
    },
    getDepositBlacklist() {
      apiDepositBlacklist().then(resp => {
        resp.data.data
          ? this.$router.push({ path: '/depositFunds' })
          : this.$message({
              message: this.$t('responseMsg.568'),
              type: 'error',
            })
      })
    },
  },
  watch: {
    $route: {
      handler() {
        this.checkDeposits()
        if (this.tradingToolUrl) {
          this.setPath()
        }
      },
    },
  },
  computed: {
    tradingToolUrl() {
      return this.$store.state.common.tradingToolUrl
    },
    minLimit() {
      return COUNTRY_MIN_LIMIT(this.isAcuitySignalCentre)
    },
  },
}
